import { createModal, hideModal } from './modal';

const THREE_D_SECURE_CHALLENGE_IFRAME_ID = 'challengeIframe';

const CHALLENGE_MODAL_ID = 'tyro-3dsecure-challenge';

const create3DSChallengeIframe = (challengeUrl: string): HTMLIFrameElement => {
  const iframe = document.createElement('iframe');
  iframe.src = challengeUrl;
  iframe.id = THREE_D_SECURE_CHALLENGE_IFRAME_ID;
  iframe.name = THREE_D_SECURE_CHALLENGE_IFRAME_ID;
  iframe.width = '100%';
  iframe.height = '100%';
  return iframe;
};

export const close3DSecureChallenge = (): void => {
  hideModal(CHALLENGE_MODAL_ID);
};

export const invoke3DSecureChallenge = (challengeUrl: string): void => {
  const challengeIframe = create3DSChallengeIframe(challengeUrl);
  const challengeModal = createModal(CHALLENGE_MODAL_ID, challengeIframe);
  document.body.appendChild(challengeModal);
};
